import { render, staticRenderFns } from "./ListItemValorFilterBar.vue?vue&type=template&id=761dea1b"
import script from "./ListItemValorFilterBar.vue?vue&type=script&lang=js"
export * from "./ListItemValorFilterBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports